import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=eae225a2&scoped=true&"
import script from "./Widget.vue?vue&type=script&lang=js&"
export * from "./Widget.vue?vue&type=script&lang=js&"
import style0 from "./Widget.vue?vue&type=style&index=0&id=eae225a2&lang=scss&scoped=true&"
import style1 from "./Widget.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae225a2",
  null
  
)

export default component.exports